import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgSource = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.3333 3.99984H8.00001L6.66668 2.6665H2.66668C1.93334 2.6665 1.34001 3.2665 1.34001 3.99984L1.33334 11.9998C1.33334 12.7332 1.93334 13.3332 2.66668 13.3332H13.3333C14.0667 13.3332 14.6667 12.7332 14.6667 11.9998V5.33317C14.6667 4.59984 14.0667 3.99984 13.3333 3.99984ZM9.33334 10.6665H4.00001V9.33317H9.33334V10.6665ZM12 7.99984H4.00001V6.6665H12V7.99984Z",
		fill: "inherit"
	})
});
export default SvgSource;
